import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { projectSettingsCustomerServiceManagementFeaturesRoute } from '@jira/router-routes__project-settings-customer-service-routes/src/projectSettingsCustomerServiceManagementFeaturesRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { featuresResource } from '@jira/router-resources__service-project-features/src/featuresResource.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { projectSettingFeaturesAppPageEntryPoint } from './ui/project-settings-features/index.tsx';

export const projectSettingsCustomerServiceManagementFeaturesRouteEntry: Route = createEntry(
	projectSettingsCustomerServiceManagementFeaturesRoute,
	() => ({
		group: 'project-settings-customer-service',
		ufoName: 'jcs-project-settings.features',

		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		entryPoint: () =>
			fg('csm_appification_standalone_navigation')
				? projectSettingFeaturesAppPageEntryPoint
				: notFoundPageEntrypoint,

		resources: [...getServiceDeskSettingsResources(), featuresResource],

		forPaint: [LazyAtlassianNavigation],
		perfMetricKey: 'jcs-project-settings.features',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
